"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Active = void 0;
const index_1 = require("./index");
class Active {
    constructor(service, 
    // eslint-disable-next-line
    data) {
        this.service = service;
        switch (data.kind) {
            case "IActiveUmacare":
                this.active = new index_1.ActiveUmacare(data);
                break;
            case "IActiveDerivation":
                this.active = new index_1.ActiveDerivation(data);
                break;
            case "IActiveCall":
                this.active = new index_1.ActiveCall(data);
                break;
            case "IActiveHisopado":
                this.active = new index_1.ActiveHisopado(data);
                break;
            default:
                throw `provided service is not valid ${this.service}`;
                break;
        }
    }
}
exports.Active = Active;
